var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchModule } from '../hooks/useSearchModule';
import { useLocationContext } from '../hooks/useLocationContext';
import { IconTile } from './IconTile';
import { LazyImage } from './LazyImage';
import { LiveLabel } from './LiveLabel';
export function SectionItem(_a) {
    var { icon, forceIcon, internalLink, href, more, long, className, onClick, action, onAction, dangerouslySetInnerHTML, children, cutTitle, cutDescription, expectedTitle, expectedDescription, id, searchSection, position, inPlay, isCasino } = _a, props = __rest(_a, ["icon", "forceIcon", "internalLink", "href", "more", "long", "className", "onClick", "action", "onAction", "dangerouslySetInnerHTML", "children", "cutTitle", "cutDescription", "expectedTitle", "expectedDescription", "id", "searchSection", "position", "inPlay", "isCasino"]);
    const searchModule = useSearchModule();
    const { urlService } = useLocationContext();
    const relativePath = (urlService === null || urlService === void 0 ? void 0 : urlService.getSportsbookRelativePath(href, isCasino)) || href;
    const url = isCasino ? relativePath : (urlService === null || urlService === void 0 ? void 0 : urlService.getSportsbookUrl(relativePath)) || '';
    const finalClassName = cls('WhSearch-SectionItem', className, {
        'WhSearch-SectionItem--long': long,
    }, [
        expectedTitle || expectedDescription
            ? `WhSearch-SectionItem--expected-title-${expectedTitle || 0}-description-${expectedDescription || 0}`
            : null,
        cutTitle ? `WhSearch-SectionItem--cut-title-${expectedTitle}` : null,
        cutDescription ? `WhSearch-SectionItem--cut-description-${expectedDescription}` : null,
    ]);
    const click = (event) => {
        if (onClick || (internalLink && url)) {
            event.preventDefault();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (internalLink && url) {
            searchModule.emit('redirect', { url, id, searchSection, position });
        }
        else if (url) {
            searchModule.emit('outer_redirect', { url, id, searchSection, position });
        }
    };
    const callAction = onAction
        ? (event) => {
            event.preventDefault();
            event.stopPropagation();
            onAction === null || onAction === void 0 ? void 0 : onAction();
        }
        : undefined;
    const Tag = href || onClick ? 'a' : 'div';
    const actionButton = action ? (React.createElement("button", { className: "WhSearch-SectionItem__action", type: "button", onClick: callAction },
        React.createElement(IconTile, { icon: action }))) : null;
    const moreElement = more ? React.createElement("div", { className: "WhSearch-SectionItem__more" }, more) : null;
    const iconInnerElement = typeof icon === 'string' ? (React.createElement(LazyImage, { src: icon, alt: "" })) : icon ? (React.createElement(FontAwesomeIcon, { icon: icon })) : null;
    const iconElement = icon || forceIcon ? (React.createElement("figure", { className: "WhSearch-SectionItem__icon" }, iconInnerElement)) : null;
    return (React.createElement(Tag, Object.assign({ className: finalClassName, href: relativePath, onClick: click }, props),
        iconElement,
        React.createElement("span", { className: "WhSearch-SectionItem__content", dangerouslySetInnerHTML: dangerouslySetInnerHTML },
            inPlay ? React.createElement(LiveLabel, null) : null,
            children),
        moreElement,
        actionButton));
}
//# sourceMappingURL=SectionItem.js.map